export const MAX_TEST_SET_DISPLAY_NAME_LENGTH = 100

export const TEST_SET_ATTACHMENT_LIMITS = {
  maxFiles: 1,
  maxFileSizeBytes: 500 * 1024, // 500KB per file (~125k tokens)
  maxTotalSizeBytes: 500 * 1024, // 500KB total (single file)
  allowedExtensions: [".txt", ".json", ".md", ".csv"],
  allowedMimeTypes: [
    "text/plain",
    "application/json",
    "text/markdown",
    "text/csv",
  ],
} as const

export const TEST_SET_IMPORT_LIMITS = {
  maxFileSizeBytes: 10 * 1024 * 1024, // 10MB per import file
  allowedExtensions: [".csv", ".xlsx"],
} as const
